export const dramas = [
  {
    id: "mu-se-hui-sheng",
    title: "暮色回声",
    type: "电视剧",
    region: "中国大陆",
    year: 2024,
    genres: ["都市", "悬疑", "犯罪"],
    director: "陆一帆",
    cast: [
      { actorId: "shen-yi-zhou", name: "沈亦舟", role: "饰 江砚（刑警队长）" },
      { actorId: "lin-zhi-yao", name: "林知遥", role: "饰 苏黎（法医）" },
      { actorId: "jiang-shu-tong", name: "江疏桐", role: "饰 罗蔓（记者）" },
    ],
    synopsis: "一桩尘封十年的悬案重新浮出水面，刑警江砚与法医苏黎循着一段断续的录音，走进城市暮色深处的真相。",
    plot:
      "十年前的雨夜，城南废弃工厂发生一起离奇命案，唯一的目击者却在案发后人间蒸发。刑警队长江砚一直未能放下这桩悬案。当一卷被修复的旧录音带出现在证物室时，断续的声音再次指向那个雨夜。他与法医苏黎联手，从一枚被忽略的指纹、一段被剪辑的通话记录入手，层层剥开被时间掩埋的关系网。随着调查深入，江砚发现真相与自己的过去紧密相连，而真正的凶手始终在暮色中静静注视着一切。剧集以冷峻的城市质感与细腻的人物刻画，讲述正义与救赎的故事。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20suspense%20drama%20key%20art%20illustration%2C%20lonely%20detective%20silhouette%20in%20rainy%20city%20alley%20at%20dusk%2C%20deep%20navy%20blue%20tones%20with%20warm%20amber%20streetlight%20accent%2C%20moody%20atmospheric%20lighting%2C%20film%20grain%2C%20highly%20detailed%2C%20no%20text%2C%20no%20watermark&width=600&height=900&seq=drama-muse-poster&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=cinematic%20suspense%20city%20skyline%20at%20rainy%20dusk%2C%20deep%20navy%20blue%20atmosphere%20with%20warm%20orange%20window%20lights%2C%20fog%20and%20reflections%20on%20wet%20streets%2C%20dramatic%20moody%20lighting%2C%20abstract%20artistic%20film%20style%2C%20no%20text&width=1600&height=900&seq=drama-muse-hero&orientation=landscape",
    rating: 8.6,
    popularity: 96,
    releaseDate: "2024-09-18",
    tags: ["年度悬疑", "口碑之作", "都市质感"],
  },
  {
    id: "yun-shang-gui-tu",
    title: "云上归途",
    type: "电视剧",
    region: "中国大陆",
    year: 2023,
    genres: ["年代", "家庭", "剧情"],
    director: "宋婉",
    cast: [
      { actorId: "su-wan-ning", name: "苏晚凝", role: "饰 何知秋" },
      { actorId: "xu-nan-chuan", name: "许南川", role: "饰 何长风" },
    ],
    synopsis: "一座山城、三代人的迁徙与守望，妹妹何知秋用三十年时间，把散落各地的家人重新带回云上老宅。",
    plot:
      "故事从上世纪八十年代的一座山城车站讲起。父亲何长风是一名铁路信号工，母亲去世后，他把三个孩子分别托付给亲戚，自己留守信号站。多年后，小妹何知秋长大成人，执意要找回散落天涯的家人。她沿着父亲的足迹，走过一条条旧铁道线与山间小路，遇见形形色色的普通人，也逐渐读懂了父亲当年的沉默。剧集用温暖克制的笔触，描摹时代变迁中的家庭羁绊，讲述“回家”这件朴素又珍贵的事。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20nostalgic%20family%20drama%20key%20art%2C%20young%20woman%20looking%20at%20mountain%20town%20and%20old%20railway%20at%20golden%20sunset%2C%20soft%20muted%20tones%20with%20amber%20warmth%2C%20gentle%20nostalgic%20lighting%2C%20illustrated%20cinematic%20style%2C%20highly%20detailed%2C%20no%20text&width=600&height=900&seq=drama-yunshang-poster&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=nostalgic%20mountain%20town%20with%20old%20railway%20tracks%20at%20golden%20hour%2C%20warm%20amber%20and%20soft%20grey%20tones%2C%20layered%20hills%20and%20mist%2C%20artistic%20painterly%20cinematic%20style%2C%20emotional%20warm%20atmosphere%2C%20no%20text&width=1600&height=900&seq=drama-yunshang-hero&orientation=landscape",
    rating: 8.9,
    popularity: 82,
    releaseDate: "2023-11-06",
    tags: ["年代温情", "豆瓣高分", "家庭史诗"],
  },
  {
    id: "xing-chen-zhi-yue",
    title: "星尘之约",
    type: "电影",
    region: "中国大陆",
    year: 2024,
    genres: ["科幻", "冒险", "剧情"],
    director: "江辰",
    cast: [
      { actorId: "gu-jing-shen", name: "顾景深", role: "饰 陆星野（宇航员）" },
      { actorId: "wen-yi-ning", name: "温以宁", role: "饰 林晚（天体物理学家）" },
    ],
    synopsis: "在距地球四光年的星系，两名宇航员用一段跨越时间的信号，兑现了一场持续二十年的约定。",
    plot:
      "人类首次深空载人任务飞向比邻星系，宇航员陆星野在漫长的休眠与苏醒之间，始终保持着与地面天体物理学家林晚的通信。信号每单程需要四年才能抵达，两人用一段段迟到的留言，穿越时间与孤独，分享着地球的四季与星空的秘密。当任务遭遇意外，陆星野必须在天命与约定之间做出选择。影片以宏大的宇宙景观包裹着一段克制的深情，探讨人类在浩瀚时空中的渺小与执着。",
    cover:
      "https://readdy.ai/api/search-image?query=epic%20science%20fiction%20film%20poster%20key%20art%2C%20lone%20astronaut%20facing%20vast%20nebula%20and%20ringed%20planet%2C%20deep%20navy%20space%20with%20warm%20orange%20nebula%20glow%2C%20cinematic%20dramatic%20lighting%2C%20highly%20detailed%2C%20no%20text%2C%20no%20watermark&width=600&height=900&seq=drama-xingchen-poster&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=epic%20space%20scene%20with%20distant%20planet%20and%20glowing%20nebula%2C%20deep%20navy%20blue%20cosmos%20with%20warm%20orange%20starlight%20accent%2C%20dramatic%20cinematic%20atmosphere%2C%20artistic%20film%20style%2C%20highly%20detailed%2C%20no%20text&width=1600&height=900&seq=drama-xingchen-hero&orientation=landscape",
    rating: 8.4,
    popularity: 91,
    releaseDate: "2024-07-26",
    tags: ["科幻大片", "视觉效果", "跨时空情感"],
  },
  {
    id: "mei-gui-yu-jing-ji",
    title: "玫瑰与荆棘",
    type: "电视剧",
    region: "中国大陆",
    year: 2024,
    genres: ["都市", "情感", "剧情"],
    director: "周楷",
    cast: [
      { actorId: "bai-qing-ge", name: "白清歌", role: "饰 姜玫" },
      { actorId: "huo-yu-heng", name: "霍聿珩", role: "饰 傅凛" },
    ],
    synopsis: "一位白手起家的女设计师，在事业与情感的双重荆棘中，重新定义属于自己的盛放方式。",
    plot:
      "姜玫从一间小小的裁缝铺起步，凭借敏锐的审美与不服输的劲头，在竞争激烈的时装行业站稳脚跟。然而光鲜背后，她要面对资本的围猎、同行的暗算，以及一段若即若离的感情。傅凛是投资人也是旧识，他既欣赏姜玫的锋芒，又总是站在她对立面。两人在一次次交锋与和解中，逐渐看清彼此的软肋。剧集以都市女性成长为主线，讲述一个关于独立、选择与和解的故事。",
    cover:
      "https://readdy.ai/api/search-image?query=stylish%20urban%20drama%20key%20art%2C%20confident%20elegant%20woman%20in%20modern%20fashion%20studio%20with%20red%20roses%2C%20navy%20and%20cream%20palette%20with%20warm%20orange%20accent%2C%20editorial%20cinematic%20lighting%2C%20highly%20detailed%2C%20no%20text&width=600&height=900&seq=drama-meigui-poster&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=elegant%20modern%20fashion%20atelier%20with%20draped%20fabric%20and%20roses%2C%20deep%20navy%20and%20cream%20tones%20with%20warm%20orange%20light%2C%20editorial%20cinematic%20atmosphere%2C%20artistic%20photography%20style%2C%20no%20text&width=1600&height=900&seq=drama-meigui-hero&orientation=landscape",
    rating: 8.1,
    popularity: 88,
    releaseDate: "2024-08-15",
    tags: ["都市女性", "职场成长", "高热度"],
  },
  {
    id: "wu-sheng-zhi-cheng",
    title: "无声之城",
    type: "网剧",
    region: "中国大陆",
    year: 2024,
    genres: ["犯罪", "悬疑", "剧情"],
    director: "韩野",
    cast: [
      { actorId: "shen-yi-zhou", name: "沈亦舟", role: "饰 韩默" },
      { actorId: "su-wan-ning", name: "苏晚凝", role: "饰 林霁" },
    ],
    synopsis: "当一座城市陷入无人发声的沉默，一个失聪的取证专家，用眼睛看见了所有人都忽略的真相。",
    plot:
      "韩默因一次意外失去听力，却练就了超乎常人的观察力。他受雇于一家调查机构，专门从监控与现场细节中还原事实。当一系列看似无关的失踪案接连发生，整座城市却异常沉默，报案记录被悄悄删除，证人也陆续噤声。韩默与搭档林霁从一段没有声音的监控画面里，读出了被刻意掩盖的节奏。剧集以独特的视听语言，讲述在沉默中坚持发声的勇气。",
    cover:
      "https://readdy.ai/api/search-image?query=gritty%20crime%20thriller%20key%20art%2C%20silent%20man%20observing%20surveillance%20screens%20in%20dark%20room%2C%20cold%20navy%20blue%20with%20sharp%20orange%20monitor%20glow%2C%20tense%20moody%20cinematic%20lighting%2C%20highly%20detailed%2C%20no%20text&width=600&height=900&seq=drama-wusheng-poster&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=moody%20dark%20city%20street%20at%20night%20with%20surveillance%20cameras%20and%20neon%20reflections%2C%20deep%20navy%20blue%20with%20warm%20orange%20highlights%2C%20tense%20cinematic%20atmosphere%2C%20artistic%20film%20style%2C%20no%20text&width=1600&height=900&seq=drama-wusheng-hero&orientation=landscape",
    rating: 8.3,
    popularity: 85,
    releaseDate: "2024-06-20",
    tags: ["犯罪悬疑", "罪案黑马", "强节奏"],
  },
  {
    id: "shan-hai-huan-meng-lu",
    title: "山海幻梦录",
    type: "网剧",
    region: "中国大陆",
    year: 2024,
    genres: ["古装", "奇幻", "爱情"],
    director: "白墨",
    cast: [
      { actorId: "lin-zhi-yao", name: "林知遥", role: "饰 云绾" },
      { actorId: "gu-jing-shen", name: "顾景深", role: "饰 沈烬" },
    ],
    synopsis: "少女云绾误入山海秘境，与沉睡千年的守梦人沈烬相遇，一同修补破碎的梦境山河。",
    plot:
      "云绾自幼能梦见常人看不见的异兽与山川。一次意外，她坠入名为“山海”的幻境，遇见了沉睡千年的守梦人沈烬。这里的世界正被一场缓慢的梦魇吞噬，山川化作碎影，异兽失去归途。为了回到现实，云绾必须与沈烬结伴，逐一修补五处碎裂的梦境核心。旅途中，他们遇见贪吃的九尾狐、固执的守山人，也揭开沈烬沉睡千年的秘密。剧集以瑰丽的东方奇幻美学，讲述守护与重逢的故事。",
    cover:
      "https://readdy.ai/api/search-image?query=oriental%20fantasy%20drama%20key%20art%2C%20young%20woman%20in%20flowing%20ancient%20robe%20before%20misty%20mountains%20and%20mythical%20beast%2C%20ink%20wash%20navy%20and%20gold%20accents%2C%20ethereal%20cinematic%20lighting%2C%20highly%20detailed%2C%20no%20text&width=600&height=900&seq=drama-shanhai-poster&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=ethereal%20oriental%20mythical%20mountain%20landscape%20with%20floating%20islands%20and%20mist%2C%20deep%20navy%20and%20soft%20gold%20tones%2C%20dreamlike%20fantasy%20atmosphere%2C%20artistic%20painterly%20style%2C%20no%20text&width=1600&height=900&seq=drama-shanhai-hero&orientation=landscape",
    rating: 8.0,
    popularity: 79,
    releaseDate: "2024-05-28",
    tags: ["东方奇幻", "唯美画风", "古装热剧"],
  },
  {
    id: "tie-dao-wang-shi",
    title: "铁道往事",
    type: "电视剧",
    region: "中国大陆",
    year: 2023,
    genres: ["年代", "剧情", "励志"],
    director: "沈括",
    cast: [
      { actorId: "xu-nan-chuan", name: "许南川", role: "饰 郑铁生" },
      { actorId: "wen-yi-ning", name: "温以宁", role: "饰 白桦" },
    ],
    synopsis: "一名年轻的铁路检修工，用二十年的时间见证一条老铁路线的兴衰与重生。",
    plot:
      "郑铁生 nineteen 岁那年成为铁路检修队里最年轻的工人。他跟着老师傅学习听音辨障，把每一段铁轨都当作自己的孩子。随着时代发展，老线路面临改造与停运，身边的工友一个个离开，郑铁生却选择留下。他与信号员白桦一起，守护着这条承载了无数人记忆的铁道。多年后，当一列崭新的列车重新驶过，往事如潮水般涌来。剧集以朴素的视角，致敬平凡岗位上的坚守。",
    cover:
      "https://readdy.ai/api/search-image?query=nostalgic%20period%20drama%20key%20art%2C%20young%20railway%20worker%20standing%20by%20old%20iron%20tracks%20and%20train%2C%20warm%20muted%20sepia%20with%20navy%20and%20orange%20accents%2C%20cinematic%20nostalgic%20lighting%2C%20highly%20detailed%2C%20no%20text&width=600&height=900&seq=drama-tiedao-poster&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=old%20railway%20line%20through%20countryside%20at%20sunset%20with%20vintage%20train%2C%20warm%20amber%20and%20muted%20navy%20tones%2C%20nostalgic%20cinematic%20atmosphere%2C%20artistic%20film%20style%2C%20no%20text&width=1600&height=900&seq=drama-tiedao-hero&orientation=landscape",
    rating: 8.5,
    popularity: 74,
    releaseDate: "2023-09-12",
    tags: ["年代励志", "现实主义", "平凡英雄"],
  },
  {
    id: "ni-liu-er-shang",
    title: "逆流而上",
    type: "电视剧",
    region: "中国大陆",
    year: 2024,
    genres: ["职场", "金融", "剧情"],
    director: "范文远",
    cast: [
      { actorId: "huo-yu-heng", name: "霍聿珩", role: "饰 谢知行" },
      { actorId: "jiang-shu-tong", name: "江疏桐", role: "饰 舒曼" },
    ],
    synopsis: "一场突如其来的金融风暴，让年轻的操盘手谢知行从云端跌落，他必须从零开始重新证明自己。",
    plot:
      "谢知行曾是业内最被看好的年轻操盘手，一次判断失误让他背负巨额损失，也失去了所有人的信任。跌入谷底后，他隐姓埋名进入一家小机构，从最基础的研究员做起。面对行业的明争暗斗与资本的博弈，他一步步重建自己的投资哲学。舒曼是他的前同事，也是唯一愿意相信他的人。剧集以写实的行业细节，讲述一个人如何在逆流中重新找到方向与初心。",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20business%20drama%20key%20art%2C%20determined%20young%20man%20in%20suit%20before%20city%20skyline%20at%20dawn%2C%20deep%20navy%20blue%20with%20warm%20orange%20sunrise%20accent%2C%20cinematic%20dramatic%20lighting%2C%20highly%20detailed%2C%20no%20text&width=600&height=900&seq=drama-niliu-poster&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=modern%20financial%20district%20skyline%20at%20blue%20hour%20with%20glowing%20windows%2C%20deep%20navy%20tones%20with%20warm%20orange%20highlights%2C%20cinematic%20corporate%20atmosphere%2C%20artistic%20style%2C%20no%20text&width=1600&height=900&seq=drama-niliu-hero&orientation=landscape",
    rating: 7.9,
    popularity: 86,
    releaseDate: "2024-04-10",
    tags: ["职场励志", "金融题材", "强代入"],
  },
  {
    id: "shen-hai-deng-ta",
    title: "深海灯塔",
    type: "电影",
    region: "中国大陆",
    year: 2023,
    genres: ["灾难", "科幻", "剧情"],
    director: "江辰",
    cast: [
      { actorId: "gu-jing-shen", name: "顾景深", role: "饰 方屿（深海工程师）" },
      { actorId: "bai-qing-ge", name: "白清歌", role: "饰 陆昭（领航员）" },
    ],
    synopsis: "深海钻井平台突发泄漏，工程师方屿与领航员陆昭必须在氧气耗尽前，点亮那座最后的“灯塔”。",
    plot:
      "位于海面下三千米的深海钻井平台突发失控泄漏，通讯中断，撤离通道被毁。工程师方屿熟悉平台的每一条管路，领航员陆昭则掌握着唯一的潜水器。两人临危受命，深入漆黑的海底修复紧急阀门。随着氧气一点点耗尽，他们不仅要对抗巨大的水压与低温，还要面对彼此之间未曾言明的过往。影片以沉浸式的深海视听，讲述绝境中人与人之间的信任与担当。",
    cover:
      "https://readdy.ai/api/search-image?query=deep%20sea%20disaster%20film%20key%20art%2C%20diver%20before%20underwater%20platform%20with%20glowing%20lamp%2C%20deep%20navy%20abyss%20with%20warm%20orange%20light%20beams%2C%20cinematic%20dramatic%20lighting%2C%20highly%20detailed%2C%20no%20text&width=600&height=900&seq=drama-shenhai-poster&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=cinematic%20deep%20ocean%20abyss%20with%20underwater%20lighthouse%20beam%2C%20deep%20navy%20blue%20with%20warm%20orange%20glow%2C%20dramatic%20tense%20atmosphere%2C%20artistic%20film%20style%2C%20no%20text&width=1600&height=900&seq=drama-shenhai-hero&orientation=landscape",
    rating: 8.2,
    popularity: 80,
    releaseDate: "2023-12-29",
    tags: ["灾难大片", "深海沉浸", "视听震撼"],
  },
  {
    id: "chun-feng-du-chang-an",
    title: "春风渡长安",
    type: "网剧",
    region: "中国大陆",
    year: 2024,
    genres: ["古装", "爱情", "剧情"],
    director: "柳如烟",
    cast: [
      { actorId: "bai-qing-ge", name: "白清歌", role: "饰 沈折枝" },
      { actorId: "cheng-yi-fan", name: "程亦凡", role: "饰 裴砚" },
    ],
    synopsis: "长安城里，一位擅画折枝花的画师与年轻少卿因一幅画卷结缘，卷入一场关乎城坊百姓的旧案。",
    plot:
      "沈折枝是长安西市里小有名气的画师，专画折枝花鸟。一次偶然，她的画卷被少卿裴砚买走，画中一处不经意的细节，竟与一桩旧案有关。两人因画结缘，携手查访西市坊间的疑云。裴砚外表冷峻、行事果决，却珍藏着姐姐留下的旧画笔；沈折枝看似柔弱，却有着不肯低头的倔强。剧集以细腻的古典美学与鲜活的人物，讲述一段发生在长安春风里的故事。",
    cover:
      "https://readdy.ai/api/search-image?query=romantic%20ancient%20chinese%20drama%20key%20art%2C%20elegant%20female%20painter%20with%20flower%20scroll%20under%20blossom%20tree%2C%20navy%20ink%20with%20soft%20pink%20and%20gold%20accents%2C%20ethereal%20cinematic%20lighting%2C%20highly%20detailed%2C%20no%20text&width=600&height=900&seq=drama-chunfeng-poster&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20palace%20city%20avenue%20in%20spring%20with%20blossom%20petals%2C%20deep%20navy%20and%20soft%20gold%20tones%2C%20romantic%20ethereal%20cinematic%20atmosphere%2C%20artistic%20painterly%20style%2C%20no%20text&width=1600&height=900&seq=drama-chunfeng-hero&orientation=landscape",
    rating: 7.8,
    popularity: 83,
    releaseDate: "2024-03-22",
    tags: ["古装甜剧", "唯美长安", "高颜值"],
  },
  {
    id: "zhui-guang-zhe",
    title: "追光者",
    type: "电视剧",
    region: "中国大陆",
    year: 2024,
    genres: ["青春", "励志", "剧情"],
    director: "高远",
    cast: [
      { actorId: "cheng-yi-fan", name: "程亦凡", role: "饰 周野" },
      { actorId: "wen-yi-ning", name: "温以宁", role: "饰 夏禾" },
    ],
    synopsis: "一群在小城长大的年轻人，用一支不知名的乐队，追逐着属于自己的那束光。",
    plot:
      "周野在南方小城的一间旧琴行里学吉他，梦想有一天能站在真正的舞台上。他与主唱夏禾、鼓手阿城等人组建了乐队“追光”。没有背景、没有资源，他们靠在酒吧驻唱、街头演出积攒每一分演出费，也一次次被现实泼冷水。在梦想与生活的拉扯中，有人动摇，有人离开，也有人咬牙坚持。剧集以清亮的青春质感，讲述年轻人如何把喜欢的事坚持到底。",
    cover:
      "https://readdy.ai/api/search-image?query=youth%20music%20drama%20key%20art%2C%20young%20band%20playing%20on%20small%20stage%20with%20glowing%20lights%2C%20deep%20navy%20blue%20with%20warm%20orange%20stage%20glow%2C%20energetic%20cinematic%20lighting%2C%20highly%20detailed%2C%20no%20text&width=600&height=900&seq=drama-zhuiguang-poster&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=small%20city%20rooftop%20at%20dusk%20with%20young%20people%20and%20guitar%20silhouettes%2C%20deep%20navy%20sky%20with%20warm%20orange%20sunset%20glow%2C%20hopeful%20cinematic%20atmosphere%2C%20artistic%20film%20style%2C%20no%20text&width=1600&height=900&seq=drama-zhuiguang-hero&orientation=landscape",
    rating: 8.0,
    popularity: 77,
    releaseDate: "2024-02-14",
    tags: ["青春励志", "治愈系", "音乐梦想"],
  },
  {
    id: "mi-wu-dang-an",
    title: "迷雾档案",
    type: "网剧",
    region: "中国大陆",
    year: 2023,
    genres: ["刑侦", "悬疑", "犯罪"],
    director: "韩野",
    cast: [
      { actorId: "shen-yi-zhou", name: "沈亦舟", role: "饰 秦戈" },
      { actorId: "lin-zhi-yao", name: "林知遥", role: "饰 温青" },
    ],
    synopsis: "一份十年前的旧档案突然被人匿名寄出，刑侦队长秦戈与档案员温青循线追查，揭开被时间封印的谜团。",
    plot:
      "刑侦队长秦戈收到一份匿名寄出的旧档案，里面是一桩早已结案的失踪案。案卷中的矛盾之处、被涂改的日期、以及一张模糊的照片，都指向同一个被遗忘的名字。他与档案室管理员温青一起，重新走访当年的证人。随着调查推进，他们发现这桩看似孤立的旧案，竟与城市里另外几起悬案有着隐秘的联系。剧集结构环环相扣，讲述真相如何在迷雾中被一点点拼回原貌。",
    cover:
      "https://readdy.ai/api/search-image?query=crime%20investigation%20key%20art%2C%20detective%20examining%20old%20case%20files%20under%20single%20lamp%2C%20dark%20navy%20with%20warm%20orange%20lamp%20glow%2C%20mysterious%20cinematic%20lighting%2C%20highly%20detailed%2C%20no%20text&width=600&height=900&seq=drama-miwu-poster&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=moody%20archive%20room%20with%20fog%20and%20old%20files%20under%20warm%20lamps%2C%20deep%20navy%20blue%20with%20amber%20accents%2C%20mysterious%20cinematic%20atmosphere%2C%20artistic%20film%20style%2C%20no%20text&width=1600&height=900&seq=drama-miwu-hero&orientation=landscape",
    rating: 8.4,
    popularity: 76,
    releaseDate: "2023-08-08",
    tags: ["刑侦悬疑", "环环相扣", "烧脑佳作"],
  },
];